<template>
  <div id="container">
    <div class="location">
      <ul>
        <li class="home">홈</li>
        <li>적하보험</li>
        <li>계약</li>
        <li>청약 입력/조회 및 증권출력</li>
      </ul>
    </div>

    <div class="pageTit">
      <div class="conWrap">
        <h2>계약 조회 및 증권 출력</h2>
        <div class="depLink">
          <button type="button" title="메뉴">
            <span>청약 입력/조회 및 증권출력</span>
          </button>
          <ul>
            <li>
              <a href="#"><span>알아두실 사항</span></a>
            </li>
            <li>
              <a href="#"><span>청약 입력/조회 및 증권출력</span></a>
            </li>
            <li>
              <a href="#"><span>증권 간략 정정</span></a>
            </li>
            <li>
              <a href="#"><span>미납조회</span></a>
            </li>
            <li>
              <a href="#"><span>계약 통계</span></a>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div class="contents">
      <div class="conWrap">
        <div class="tabBtn">
          <router-link to="/sbcpInpInqNdPolOtpt"
            ><span>청약 입력</span></router-link
          >
          <router-link to="/subsRstList"
            ><span>청약 결과 조회</span></router-link
          >

          <router-link to="/getPolList" class="active"
            ><span>계약 조회 및 증권 출력</span></router-link
          >
        </div>

        <div class="sortWrap">
          <dl class="w730 mgr20">
            <dt>조회조건</dt>
            <dd>
              <div class="split">
                <div class="inpSlt w265 mgr20">
                  <button type="button" class="sltBtn" title="조건 선택">
                    <span>기간</span>
                  </button>
                  <ul>
                    <li
                      v-for="(item, index) in state.getSeachType"
                      :key="index"
                    >
                      <button
                        type="button"
                        class="sltOpt"
                        title="전체"
                        @click="onSelectEvent('SeachType', item)"
                      >
                        <span>{{ item.name }}</span>
                      </button>
                    </li>
                  </ul>
                </div>
                <div
                  v-show="state.SeachType == '1'"
                  class="form_input_area type_calendar"
                  style="width: 47%"
                >
                  <datepicker
                    v-model="state.dateInfo.inpStDt"
                    :locale="ko"
                    class="form_input"
                    typeable
                    ref="startDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar" @click="openCalendar('startDate')" @blur="closeCalendar('startDate')">
                    <span>날짜선택</span>
                  </button>
                </div>
                <span
                  v-show="state.SeachType == '1'"
                  style="margin: 13px 0px 0px 10px"
                  >~</span
                >
                <div
                  v-show="state.SeachType == '1'"
                  class="form_input_area type_calendar"
                  style="width: 46%"
                >
                  <datepicker
                    v-model="state.dateInfo.inpEdDt"
                    :locale="ko"
                    class="form_input"
                    typeable
                    ref="endDate"
                    @input="inputDate"
                    maxlength="10"
                  />
                  <button type="button" class="btn_calendar" @click="openCalendar('endDate')" @blur="closeCalendar('endDate')">
                    <span>날짜선택</span>
                  </button>
                </div>
                <input
                  v-show="state.SeachType == '2'"
                  type="text"
                  v-model="state.polNo"
                />
                <input
                  v-show="state.SeachType == '3'"
                  type="text"
                  v-model="state.refnNo"
                />
              </div>
            </dd>
          </dl>
          <dl>
            <dt class="w72">입력자</dt>
            <dd>
              <div class="inpSlt">
                <button type="button" class="sltBtn" title="입력자 선택">
                  <span>전체</span>
                </button>
                <ul>
                  <li>
                    <button type="button" class="sltOpt" title="선택">
                      <span>전체</span>
                    </button>
                  </li>
                  <!-- 체크되어있는 버튼에 title="선택" 추가 -->
                  <li>
                    <button type="button" class="sltOpt">
                      <span>{{ logId }}</span>
                    </button>
                  </li>
                </ul>
              </div>
            </dd>
          </dl>
          <button type="button" class="btnSearch" @click="fnSearch(true)">
            <span class="hide">검색</span>
          </button>
        </div>

        <h3 class="conTit">조회결과</h3>
        <div class="searchInfo">
          <div class="typeSplit1">
            <dl>
              <dt>총건수</dt>
              <dd>{{ state.ttCnt }}건</dd>
            </dl>
            <dl>
              <dt>미수건수</dt>
              <dd>{{ state.unclCnt }}건</dd>
            </dl>
            <dl>
              <dt>영수건수</dt>
              <dd>{{ state.rcptCnt }}건</dd>
            </dl>
            <dl>
              <dt>환급건수</dt>
              <dd>{{ state.rfdCnt }}건</dd>
            </dl>
          </div>
          <div class="typeSplit1">
            <dl>
              <dt>총보험료</dt>
              <dd>{{ util.addCommas(state.ttPrem) }}원</dd>
            </dl>
            <dl>
              <dt>미수보험료</dt>
              <dd>{{ util.addCommas(state.unclPrem) }}원</dd>
            </dl>
            <dl>
              <dt>영수보험료</dt>
              <dd>{{ util.addCommas(state.rcptPrem) }}원</dd>
            </dl>
            <dl>
              <dt>환급보험료</dt>
              <dd>{{ util.addCommas(state.rfdPrem) }}원</dd>
            </dl>
          </div>
          <div class="typeSplit1">
            <dl>
              <dt>계약자</dt>
              <dd>{{sessionUserInfo.userInfo.login_id}}</dd>
            </dl>
          </div>
        </div>

        <div class="tabStyle2">
          <div class="btnPrint">
            <button
              v-show="state.chkPrint != '27000'"
              type="button"
              class="btnType colorBlL sizeXS"
              @click="fnTotalPrint()"
            >
              <span>출력하기</span>
            </button>
          </div>
          <table>
            <caption>
              조회결과
            </caption>
            <colgroup>
              <col width="40" />
              <col width="*" />
              <col width="160" />
              <col width="90" />
              <col width="220" />
              <col width="140" />
              <col width="140" />
              <col width="140" />
              <col width="100" />
            </colgroup>
            <thead>
              <tr>
                <th scope="col" class="tar pdr0" height="62">
                  <div class="inpCheck">
                    <input
                      type="checkbox"
                      id="allChk"
                      v-model="state.allChk"
                      @change="fnAllChkPrint()"
                    />
                    <label for="allChk" class="pdl20"
                      ><span class="hide">전체선택</span></label
                    >
                  </div>
                </th>
                <th scope="col">구분</th>
                <th scope="col">증권번호</th>
                <th scope="col">배서</th>
                <th scope="col">Ref NO.</th>
                <th scope="col">계상일</th>
                <th scope="col">보험료(￦)</th>
                <th scope="col">출력</th>
                <th scope="col">입력자</th>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(item, index) in state.cargInetCtrLstDtlInfBcVo"
                :key="index"
              >
                <td class="tar pdr0" height="74">
                  <div class="inpCheck">
                    <input
                      type="checkbox"
                      :id="'chk1-' + index"
                      v-model="item.checked"
                      @change="onclick(state.cargInetCtrLstDtlInfBcVo, item)"
                    />
                    <label :for="'chk1-' + index" class="pdl20"
                      ><span class="hide">선택</span></label
                    >
                  </div>
                </td>
                <td>{{ item.rcptDiv }}</td>
                <td>{{ item.polNo }}</td>
                <td>{{ item.endrNo }}</td>
                <td>{{ item.refnNo }}</td>

                <td>{{ item.inpDt.substring(0, 10) }}</td>
                <td>{{ util.addCommas(item.rcptPrem) }}</td>

                <td>
                  <button
                    type="button"
                    class="btnType colorBlL sizeXS"
                    @click="fnPolPrint(item, index)"
                  >
                    <span>증권</span>
                  </button>
                  <button
                    v-if="item.endrNo > 0"
                    type="button"
                    class="btnType colorYL sizeXS"
                    @click="fnEndrPrint(item, index)"
                  >
                    <span>배서</span>
                  </button>
                </td>
                <td>-</td>
              </tr>

              <tr v-if="state.cargInetCtrLstDtlInfBcVo.length == 0">
                <td colspan="10">
                  <p class="noData">조회된 결과가 없습니다.</p>
                </td>
              </tr>
            </tbody>
          </table>
          <!-- 더보기 없을떄 삭제 영역 [s] -->
          <button
            type="button"
            class="btnMore"
            v-if="isActiveBtnMore()"
            @click="fnSearch()"
          >
            <span>더보기</span>
          </button>
          <!-- 더보기 없을떄 삭제 영역 [e] -->
        </div>
      </div>
    </div>
  </div>
  <FnPolPrint ref="fnPolPrintRef" @close="handlePopupClose"></FnPolPrint>
  <FnEndrPrint ref="fnEndrPrintRef" @close="handlePopupClose"></FnEndrPrint>
  <FnTotalPrint ref="fnTotalPrintRef" @close="handlePopupClose"></FnTotalPrint>
</template>

<script setup>
// @ is an alias to /src

import { ref, reactive, inject, onMounted, onBeforeUpdate } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import util from "@/common/util";
import { sessionUserInfo, load } from "@/common/sessionFactory";
import Header from "@/components/common/Header.vue";
import Footer from "@/components/common/Footer.vue";
import { format, subDays } from "date-fns";
import FnPolPrint from "@/components/common/layerPop/FnPolPrint.vue";
import FnEndrPrint from "@/components/common/layerPop/FnEndrPrint.vue";
import FnTotalPrint from "@/components/common/layerPop/FnTotalPrint.vue";
import * as codeList from "@/common/code";
import Datepicker from "vue3-datepicker";

const axios = inject("axios");
const swalAlert = inject("swalAlert");

let logId = ref(null);
let now = new Date();
let pageNum = ref(1);
let totalrCnt = ref(0);
let startDate = ref(null);
let endDate = ref(null);

let searchResult = ref([]);

const aa= (v) => {
  console.log(v)
}

const openCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('day')
      break;
    case "endDate":
      endDate.value.renderView('day')
      break;
  }
  
}

const closeCalendar = (tp) => {
  switch(tp) {
    case "startDate":
      startDate.value.renderView('none')
      break;
    case "endDate":
      endDate.value.renderView('none')
      break;
  }
}

const state = reactive({
  cargInetCtrLstDtlInfBcVo: [],
  cusNo: "",
  inetUsrId: "",
  inpEdDt: "",
  inpStDt: "",
  inqDiv: "",
  polNo: "",
  polhdNm: "",
  pstmPg: "1",
  rcptCnt: "", //영수건수
  rcptPrem: "", //영수보험료
  refnNo: "",
  rfdCnt: "", //환급건수
  rfdPrem: "", //환급보험료
  scrnDiv: "",
  ttCnt: "", //총건수
  ttPrem: "", //총보험료
  unclCnt: "", //미수건수
  unclPrem: "", //미수보험료

  getSeachType: [], //조회조건
  currDateFormatEd: util.formatDate(new Date(), "yyyy-mm-dd"),
  currDateFormatSt: util.formatDate(
    new Date(now.setDate(now.getDate() - 7)),
    "yyyy-mm-dd"
  ),
  SeachType: "1",
  chkPrint: "",
  dateInfo: {},
  pdCd: "",
  filterObject: [],
});

//출력
const fnPolPrintRef = ref(null);
const fnEndrPrintRef = ref(null);
const fnTotalPrintRef = ref(null);

//조회 구분 선택시
const onSelectEvent = async (selectId, data) => {
  if (selectId == "SeachType") {
    state.SeachType = data.code;
  }
};

//더보기
const isActiveBtnMore = () => {
  return (
    // searchResult.value != 0 &&
    state.cargInetCtrLstDtlInfBcVo.length != 0 &&
    state.ttCnt >= 31 &&
    state.ttCnt / 30 > state.pstmPg
  );
};

//메모저장
// const memoSave = async (d) => {
//   //빈값으로 입력시 공백
//   if(d.memoDtlCon == ""){
//     d.memoDtlCon = " "
//   }
//   let voMap = {};
//   voMap.ctrDiv = "2";
//   voMap.ctrId = d.ctrId; //"4nxJNT8FBR";
//   voMap.endrHisStdNo = d.endrHisStdNo; //"2024010200000";
//   voMap.dtlCon = d.memoDtlCon;
//   voMap.dtlSeq = d.memoDtlSeq; //"5";
//   voMap.hisSeq = d.memoHisSeq; //"1";

//   var result = await axios.transaction("FNGCTNFO0199", voMap);
//   if (result.nErrorCode == "0") {
//     swalAlert("저장되었습니다.");
//   } else {

//     swalAlert("저장되지 않았습니다.\n " + "관리자에게 문의하십시요.");
//   }
// };

//검색
const fnSearch = async (reset) => {
  if (reset) {
    state.cargInetCtrLstDtlInfBcVo = [];
    searchResult.value = []
    state.pstmPg = 1;
    state.rcptCnt = ""; //영수건수
    state.rcptPrem = ""; //영수보험료
    state.rfdCnt = ""; //환급건수
    state.rfdPrem = ""; //환급보험료
    state.scrnDiv = "";
    state.ttCnt = ""; //총건수
    state.ttPrem = ""; //총보험료
    state.unclCnt = ""; //미수건수
    state.unclPrem = ""; //미수보험료
    state.filterObject = [];//
    state.allChk = false
  } else state.pstmPg = parseInt(state.pstmPg) + 1;

  //기간 조회
  if (state.SeachType == "1") {
    //조회 기간 확인
    if ( util.formatDate(state.dateInfo.inpStDt, "yyyymmdd") > util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")) {
      swalAlert("조회기간을 확인해 주세요.");
      return;
    } else if (
      util.getDay(
        util.formatDate(state.dateInfo.inpStDt, "yyyymmdd"),
        util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd")
      ) > 8
    ) {
      swalAlert("검색기간은 8일 까지 가능합니다.");
      return;
    }
    let voMap = {};

    //let strInetUsrId = sessionUserInfo.userInfo.login_id;

    //voMap.inetUsrId = strInetUsrId; //"pangrim02"
    voMap.inpStDt = util.formatDate(state.dateInfo.inpStDt, "yyyymmdd");//"20240306"
    voMap.inpEdDt = util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd");//"20240306"
    voMap.inqDiv = "1";
    voMap.polNo = "";
    voMap.refnNo = "";

    voMap.cusNo = sessionUserInfo.slzCusInf.cusNo; // 고객번호 (cusNo); "10001326596" "20014963978"
    voMap.pstmPg = state.pstmPg//"1";
    voMap.scrnDiv = "1";

    var result = await axios.transaction("FNGCTNFO0195", voMap);
    console.log("결과 ",result);

    if (_.isEmpty(result.body?.cargInetCtrLstDtlInfBcVo)) return;
    
    //더보기
    state.cargInetCtrLstDtlInfBcVo = state.cargInetCtrLstDtlInfBcVo.concat(
      _.flatten([result.body?.cargInetCtrLstDtlInfBcVo || result.body])
    );

    //일괄 출력 27000 아닐시 show
    if (result.body.cargInetCtrLstDtlInfBcVo.pdCd != "27000") {
      state.chkPrint = result.body.cargInetCtrLstDtlInfBcVo.pdCd;
    }

    totalrCnt = result.body.ttCnt; //조회 총 개수

    // if (_.isArray(result.body.cargInetCtrLstDtlInfBcVo)) {
    //   state.cargInetCtrLstDtlInfBcVo = result.body.cargInetCtrLstDtlInfBcVo;
    // } else {
    //   state.cargInetCtrLstDtlInfBcVo.push(result.body.cargInetCtrLstDtlInfBcVo);
    // }

    state.cusNo = result.body.cusNo;
    state.inetUsrId = result.body.inetUsrId;
    state.inpEdDt = result.body.inpEdDt;
    state.inpStDt = result.body.inpStDt;
    state.inqDiv = result.body.inqDiv;
    state.polNo = result.body.polNo;
    state.polhdNm = result.body.polhdNm;
    state.pstmPg = result.body.pstmPg;
    state.rcptCnt = result.body.rcptCnt; //영수건수
    state.rcptPrem = result.body.rcptPrem; //영수보험료
    state.refnNo = result.body.refnNo;
    state.rfdCnt = result.body.rfdCnt; //환급건수
    state.rfdPrem = result.body.rfdPrem; //환급보험료
    state.scrnDiv = result.body.scrnDiv;
    state.ttCnt = result.body.ttCnt; //총건수
    state.ttPrem = result.body.ttPrem; //총보험료
    state.unclCnt = result.body.unclCnt; //미수건수
    state.unclPrem = result.body.unclPrem; //미수보험료
  }
  //증권 번호 조회
  else if (state.SeachType == "2") {
    if(state.polNo == ""){
      swalAlert("증권 번호를 입력하세요.");
      return;
    }
    console.log("증권 번호 조회");
    let voMap = {};

    //let strInetUsrId = sessionUserInfo.userInfo.login_id;

    //voMap.inetUsrId = strInetUsrId;
    voMap.inpStDt = ""//util.formatDate(state.dateInfo.inpStDt, "yyyymmdd");
    voMap.inpEdDt = ""//util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd");
    voMap.inqDiv = "2";
    voMap.polNo = state.polNo;
    voMap.refnNo = "";

    voMap.cusNo = sessionUserInfo.slzCusInf.cusNo; // 고객번호 (cusNo);
    voMap.pstmPg = state.pstmPg;
    voMap.scrnDiv = "1";

    result = await axios.transaction("FNGCTNFO0195", voMap);
    if (_.isEmpty(result.body?.cargInetCtrLstDtlInfBcVo)) return;

    //더보기
    state.cargInetCtrLstDtlInfBcVo = state.cargInetCtrLstDtlInfBcVo.concat(
      _.flatten([result.body?.cargInetCtrLstDtlInfBcVo || result.body])
    );
    console.log("더보기",searchResult.value)


    //일괄 출력 27000 아닐시 show
    if (result.body.cargInetCtrLstDtlInfBcVo.pdCd != "27000") {
      state.chkPrint = result.body.cargInetCtrLstDtlInfBcVo.pdCd;
    }
    totalrCnt = result.body.ttCnt; //조회 총 개수

    // if (_.isArray(result.body.cargInetCtrLstDtlInfBcVo)) {
    //   state.cargInetCtrLstDtlInfBcVo = result.body.cargInetCtrLstDtlInfBcVo;
    // } else {
    //   state.cargInetCtrLstDtlInfBcVo.push(result.body.cargInetCtrLstDtlInfBcVo);
    // }

    state.cusNo = result.body.cusNo;
    state.inetUsrId = result.body.inetUsrId;
    state.inpEdDt = result.body.inpEdDt;
    state.inpStDt = result.body.inpStDt;
    state.inqDiv = result.body.inqDiv;
    state.polNo = result.body.polNo;
    state.polhdNm = result.body.polhdNm;
    state.pstmPg = result.body.pstmPg;
    state.rcptCnt = result.body.rcptCnt; //영수건수
    state.rcptPrem = result.body.rcptPrem; //영수보험료
    state.refnNo = result.body.refnNo;
    state.rfdCnt = result.body.rfdCnt; //환급건수
    state.rfdPrem = result.body.rfdPrem; //환급보험료
    state.scrnDiv = result.body.scrnDiv;
    state.ttCnt = result.body.ttCnt; //총건수
    state.ttPrem = result.body.ttPrem; //총보험료
    state.unclCnt = result.body.unclCnt; //미수건수
    state.unclPrem = result.body.unclPrem; //미수보험료
  }
  //참조번호 조회
  else if (state.SeachType == "3") {
     if(state.refnNo == ""){
      swalAlert("Ref NO 를 입력하세요.");
      return;
    }
    console.log("참조번호 조회");

    let voMap = {};

    //let strInetUsrId = sessionUserInfo.userInfo.login_id;

    //voMap.inetUsrId = strInetUsrId;
    voMap.inpStDt = "" //util.formatDate(state.dateInfo.inpStDt, "yyyymmdd");
    voMap.inpEdDt = "" //util.formatDate(state.dateInfo.inpEdDt, "yyyymmdd");
    voMap.inqDiv = "3";
    voMap.polNo = "";
    voMap.refnNo = state.refnNo;

    voMap.cusNo = sessionUserInfo.slzCusInf.cusNo; // 고객번호 (cusNo);
    voMap.pstmPg =  state.pstmPg;
    voMap.scrnDiv = "1";

    result = await axios.transaction("FNGCTNFO0195", voMap);
    if (_.isEmpty(result.body?.cargInetCtrLstDtlInfBcVo)) return;

    //더보기
    state.cargInetCtrLstDtlInfBcVo = state.cargInetCtrLstDtlInfBcVo.concat(
      _.flatten([result.body?.cargInetCtrLstDtlInfBcVo || result.body])
    );
    console.log("더보기",searchResult.value)

    //일괄 출력 27000 아닐시 show
    if (result.body.cargInetCtrLstDtlInfBcVo.pdCd != "27000") {
      state.chkPrint = result.body.cargInetCtrLstDtlInfBcVo.pdCd;
    }
    totalrCnt = result.body.ttCnt; //조회 총 개수

    // if (_.isArray(result.body.cargInetCtrLstDtlInfBcVo)) {
    //   state.cargInetCtrLstDtlInfBcVo = result.body.cargInetCtrLstDtlInfBcVo;
    // } else {
    //   state.cargInetCtrLstDtlInfBcVo.push(result.body.cargInetCtrLstDtlInfBcVo);
    // }

    state.cusNo = result.body.cusNo;
    state.inetUsrId = result.body.inetUsrId;
    state.inpEdDt = result.body.inpEdDt;
    state.inpStDt = result.body.inpStDt;
    state.inqDiv = result.body.inqDiv;
    state.polNo = result.body.polNo;
    state.polhdNm = result.body.polhdNm;
    state.pstmPg = result.body.pstmPg;
    state.rcptCnt = result.body.rcptCnt; //영수건수
    state.rcptPrem = result.body.rcptPrem; //영수보험료
    state.refnNo = result.body.refnNo;
    state.rfdCnt = result.body.rfdCnt; //환급건수
    state.rfdPrem = result.body.rfdPrem; //환급보험료
    state.scrnDiv = result.body.scrnDiv;
    state.ttCnt = result.body.ttCnt; //총건수
    state.ttPrem = result.body.ttPrem; //총보험료
    state.unclCnt = result.body.unclCnt; //미수건수
    state.unclPrem = result.body.unclPrem; //미수보험료
  }
};

//증권 출력
const fnPolPrint = async (d) => {
  //증권 출력시 보내줘야하는 데이터
  let param = {
    polNo: d.polNo,
    endrHisStdNo: d.endrHisStdNo,
    salPdNm: "적하수입보험",
    ctrId: d.ctrId,
    ctfOtptDiv: "110",
  };
  let Result = await axios.transaction("FNGCTGFO0137", param);
  if (Result.msg.standCd != "FNGCT200549") {
    Result.body.ctrId = d.ctrId;
    Result.body.endrHisStdNo = d.endrHisStdNo;

    fnPolPrintRef.value.open(Result);
  } else {
    swalAlert(
      "미수증권으로 출력이 제어됩니다. 30일 이상 된 미수내역을 확인 바랍니다."
    );
    return;
  }
};

//배서 출력
const fnEndrPrint = async (d) => {
  //배서 출력시 보내줘야 하는 데이터
  let param = {
    polNo:  d.polNo,
    endrHisStdNo: d.endrHisStdNo,
    endrNo: d.endrNo,
    ctrId: d.ctrId,
    pdCd: "",
  };
  console.log(param)
  let Result = await axios.transaction("FNGCTGFO0108", param);
  console.log(Result)
  Result.body.ctrId = d.ctrId;
  Result.body.endrHisStdNo = d.endrHisStdNo;
  //Result.body.otptSh = d.otptSh;

  fnEndrPrintRef.value.open(Result);
};

//체크박스 개별 선택
const onclick = (list, data) => {
  state.filterObject = _.filter(list, function (info) {
    return info.checked == true;
  });

  if (state.filterObject.length > 30) {
    swalAlert("최대 출력 건수는 30건 입니다.");
    data.checked = false;
  }
};

//체크박스 전체 선택
const fnAllChkPrint = async () => {
  if (state.allChk) {
    _.each(state.cargInetCtrLstDtlInfBcVo, function (item, idx) {
      console.log(item);
      item.checked = true;
    });
  } else {
    _.each(state.cargInetCtrLstDtlInfBcVo, function (item, idx) {
      console.log(item);
      item.checked = false;
    });
  }
};

//일괄 출력 버튼
const fnTotalPrint = async () => {
  state.filterObject = _.filter(
    state.cargInetCtrLstDtlInfBcVo,function (info) {
      return info.checked == true;
    }
  );
  if (state.filterObject == "") {
    swalAlert("출력물을 선택 하세요.");
    return;
  }
  fnTotalPrintRef.value.open(state.filterObject);
};

init();

//페이지 진입시
async function init() {
  await load();
  console.log("로그인 정보값", sessionUserInfo);
  axios.json('/logHisLdg.do', {memo:"계약조회 및 증권출력" ,page:window.location.hash});
  logId.value = sessionUserInfo.logId;
  state.getSeachType = codeList.getSeachType;
  state.dateInfo.inpStDt = new Date(state.currDateFormatSt);
  state.dateInfo.inpEdDt = new Date(state.currDateFormatEd);

  fnSearch(true);
}
</script>

<style></style>
